import { render, staticRenderFns } from "./CollectItems.vue?vue&type=template&id=e18fb5f6&scoped=true"
import script from "./CollectItems.vue?vue&type=script&lang=js"
export * from "./CollectItems.vue?vue&type=script&lang=js"
import style0 from "./CollectItems.vue?vue&type=style&index=0&id=e18fb5f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18fb5f6",
  null
  
)

export default component.exports